import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Col,
  Content,
  ModalLayout,
  Row,
  Table,
  Text,
} from 'components';
import OrderItem from '../OrderItem/OrderItem';
import { stringToMoneyFormat } from 'utils';
import Formatter from 'utils/Formatter';
import { Flex, Input, Select } from 'antd';
import { encrypt } from 'utils/Crypto';
import dayjs from 'dayjs';
import './OrderListTable.style.css';

const DELIVER = {
  DELIVERY: '택배배송',
  SUBSCRIPTION: '정기배송',
  STORE_PICKUP: '매장픽업',
  RENTAL: '렌탈',
};

const DELIVERY_STATUS = {
  PENDING: {
    DELIVERY: '배송전',
    SUBSCRIPTION: '배송전',
    STORE_PICKUP: '주문확인중',
    RENTAL: '배송전',
  },
  PREPARING: {
    DELIVERY: '상품준비중',
    SUBSCRIPTION: '상품준비중',
    STORE_PICKUP: '상품준비중',
    RENTAL: '상품준비중',
  },
  SHIPPING: {
    DELIVERY: '배송중',
    SUBSCRIPTION: '배송중',
    STORE_PICKUP: '픽업가능',
    RENTAL: '배송중',
  },
  DELIVERED: {
    DELIVERY: '배송완료',
    SUBSCRIPTION: '배송완료',
    STORE_PICKUP: '픽업완료',
    RENTAL: '배송완료',
  },
  ON_HOLD: {
    DELIVERY: '배송보류',
    SUBSCRIPTION: '배송보류',
    STORE_PICKUP: '픽업보류',
    RENTAL: '배송보류',
  },
  EXCHANGE_REQUESTED: {
    DELIVERY: '교환신청',
    SUBSCRIPTION: '교환신청',
    STORE_PICKUP: '교환신청',
    RENTAL: '교환신청',
  },
  EXCHANGE_COMPLETED: {
    DELIVERY: '교환완료',
    SUBSCRIPTION: '교환완료',
    STORE_PICKUP: '교환완료',
    RENTAL: '교환완료',
  },
  RETURN_REQUESTED: {
    DELIVERY: '반품신청',
    SUBSCRIPTION: '반품신청',
    STORE_PICKUP: '반품신청',
    RENTAL: '반품신청',
  },
  RETURN_COMPLETED: {
    DELIVERY: '환불완료',
    SUBSCRIPTION: '환불완료',
    STORE_PICKUP: '환불완료',
    RENTAL: '환불완료',
  },
};

const REFUND_REASON = {
  CANCELLED: [
    {
      label: '단순변심',
      value: '고객 변심으로 인한 주문 취소',
    },
    {
      label: '옵션변경',
      value: '옵션 변경 후 재구매',
    },
    {
      label: '배송지변경',
      value: '배송지 변경 후 재구매',
    },
    {
      label: '배송지연',
      value: '배송지연으로 인한 주문 취소',
    },
    {
      label: '직접입력',
      value: null,
    },
  ],
  REFUNDED: [
    {
      label: '단순변심',
      value: '고객 변심으로 인한 주문 취소',
    },
    {
      label: '상품파손',
      value: '상품이 파손됨',
    },
    {
      label: '상품오설명',
      value: '상품이 설명과 다름',
    },
    {
      label: '구성품누락',
      value: '상품의 구성품/부속품이 들어있지 않음',
    },
    {
      label: '상품결함',
      value: '상품이 결함/기능에 이상이 있음',
    },
    {
      label: '배송누락',
      value: '주문한 상품 중 일부 상품이 배송되지 않음',
    },
    {
      label: '배송문제',
      value: '다른 상품이 배송됨',
    },
    {
      label: '직접입력',
      value: null,
    },
  ],
  RETURNED: [
    {
      label: '상품파손',
      value: '상품이 파손됨',
    },
    {
      label: '구성품누락',
      value: '상품의 구성품/부속품이 들어있지 않음',
    },
    {
      label: '상품결함',
      value: '상품이 결함/기능에 이상이 있음',
    },
    {
      label: '배송누락',
      value: '주문한 상품 중 일부 상품이 배송되지 않음',
    },
    {
      label: '배송문제',
      value: '다른 상품이 배송됨',
    },
    {
      label: '직접입력',
      value: null,
    },
  ],
};

const OrderListTable = ({
  orders,
  detailText = '주문상세',
  showExpectedCycle = false,
  onSubmit,
  onDetailClick,
  screenSize,
}) => {
  const navigate = useNavigate();

  /* ===== State ===== */
  const today = dayjs().unix();

  const [modalType, setModalType] = React.useState(null);
  const [modalData, setModalData] = React.useState(null);

  const [selectedValue, setSelectedValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Table
        data={orders}
        columns={[
          {
            key: 'orderDetails',
            render: (_, state) => {
              const representativeDate = Formatter.unixToDate(
                state.created_at,
                'YYYY.MM.DD',
              );

              return (
                <div
                  className="order_table_wrap"
                  // style={{
                  //   display: 'flex',
                  //   flexDirection: 'column',
                  //   borderTop: '2px solid var(--black-color)',
                  // }}
                >
                  <div>
                    <Text
                      className={'order_num'}
                      // style={{
                      //   textAlign: 'start',
                      //   fontSize: 16,
                      //   fontWeight: 'bold',
                      //   borderBottom: '1px solid #ddd',
                      //   padding: '16px 0',
                      //   display: 'flex',
                      //   justifyContent: 'space-between',
                      //   alignItems: 'center',
                      // }}
                    >
                      <div>
                        <span
                          style={{
                            fontWeight: 400,
                            paddingRight: 24,
                            width: '100%',
                          }}
                        >
                          주문번호
                        </span>
                        {state.payment_serial_number}
                      </div>
                      {detailText ? (
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 400,
                            border: '1px solid var(--black-color)',
                            padding: '2px 8px',
                            cursor: 'pointer',
                          }}
                          onClick={
                            () => onDetailClick(state)
                            // navigate(
                            //   showExpectedCycle
                            //     ? `/mypage/subscribe/${encodeURIComponent(
                            //         encrypt(state.shop_order_id)
                            //       )}` // showExpectedCycle이 true일 경우
                            //     : `/mypage/order/${encodeURIComponent(
                            //         encrypt(state.shop_order_id)
                            //       )}` // 아니면 기본값으로 orderdetails
                            // )
                          }
                        >
                          {detailText}
                        </span>
                      ) : null}
                    </Text>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '24px 0',
                    }}
                  >
                    {state?.parcel_service?.map((order, index) => (
                      <div
                        key={`order-${order.parcel_service_id}`}
                        style={{
                          marginBottom:
                            index !== state?.parcel_service?.length - 1
                              ? 32
                              : 0,
                        }}
                      >
                        <div
                          style={
                            screenSize > 1550
                              ? {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }
                              : {
                                  gap: '10px',
                                  // display: 'flex',
                                  // alignItems: 'center',
                                }
                          }
                        >
                          {/* 결제일 */}
                          <div
                            style={{
                              width: '9.36%',
                              textAlign: 'start',
                            }}
                          >
                            <Text
                              className={'representative_data'}
                              style={{
                                fontSize: 16,
                                fontWeight: 400,
                              }}
                            >
                              {screenSize > 1550 ? representativeDate : null}
                            </Text>
                          </div>
                          <div
                            style={{
                              width: screenSize > 1550 ? '45.4%' : '100%',
                            }}
                          >
                            <OrderItem
                              src={order.product.thumbnail}
                              placeName={order.product.shop_information_name}
                              productName={order.product.product_name}
                              productData={
                                order.product.product_option
                                  ? order.product.product_option
                                      .map((cur) =>
                                        cur.option
                                          .map((op) => op.option_name)
                                          .join(' / '),
                                      )
                                      .join(' / ')
                                  : null
                              }
                              onClick={() =>
                                navigate(
                                  `/products/${encodeURIComponent(
                                    encrypt(order.product.product_id),
                                  )}`,
                                )
                              }
                            />
                          </div>
                          <Text
                            className={'product_price'}
                            style={{
                              width: screenSize > 1550 ? '12.97%' : '100%',
                              fontSize: 18,
                              fontWeight: 700,
                              textAlign: screenSize > 1550 ? 'start' : 'end',
                            }}
                          >
                            {stringToMoneyFormat(order.payment_price)}
                            <span>원</span>
                          </Text>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent:
                                screenSize > 1550 ? 'space-between' : 'unset',
                              gap: screenSize > 1550 ? '' : '10px',
                              width: screenSize > 1550 ? '29.41%' : '100%',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 16,
                                  fontWeight: 400,
                                  textAlign: 'center',
                                }}
                              >
                                {DELIVER[state.type]}
                              </Text>
                              {showExpectedCycle &&
                              order.regular_payment_info ? (
                                <Text style={{ fontSize: 14, marginTop: 8 }}>
                                  {order.regular_payment_info.length}
                                  {order.regular_payment_info?.at(-1)
                                    ?.payment_state === 'REFUNDED' ? (
                                    <span>회차 환불/취소</span>
                                  ) : (
                                    <span>
                                      {order.regular_payment_info?.at(-1)
                                        ?.delivery_status === 'DELIVERED'
                                        ? '회차 배송완료'
                                        : '회차 배송예정'}
                                    </span>
                                  )}
                                </Text>
                              ) : null}
                            </div>

                            {/* SECTION 배송 상태 (일반 배송) */}
                            {!showExpectedCycle ? (
                              order?.delivery_status === 'DELIVERED' &&
                              (order?.purchase_status === 'CONFIRMED' ||
                                order?.purchase_status === 'CALCULATE') ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 18,
                                      fontWeight: 700,
                                      textAlign: 'center',
                                    }}
                                  >
                                    구매확정
                                  </Text>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2,
                                  }}
                                >
                                  <Text
                                    className={'product_refund'}
                                    style={{
                                      fontSize: 18,
                                      fontWeight: 700,
                                      textAlign: 'center',
                                    }}
                                  >
                                    {
                                      DELIVERY_STATUS[order?.delivery_status][
                                        order.type
                                      ]
                                    }
                                  </Text>
                                  {onSubmit &&
                                  order?.delivery_status === 'PENDING' &&
                                  order?.purchase_status === 'PENDING' ? (
                                    <span
                                      style={{
                                        fontSize: 14,
                                        borderRadius: 2,
                                        padding: '2px 4px',
                                        cursor: 'pointer',
                                        color: 'var(--white-color)',
                                        backgroundColor: 'var(--black-color)',
                                        marginTop: 8,
                                      }}
                                      onClick={() => {
                                        setModalType(`${order.type}-CANCELLED`);
                                        setModalData({
                                          shop_order_id: state.shop_order_id,
                                          payment_info: state.payment_info,
                                          payment_method: state.payment_method,

                                          parcel_service_id:
                                            order.parcel_service_id,
                                          refund_amount: order.payment_price,
                                          refund_num: order.num,
                                          regular_payment_info:
                                            order.regular_payment_info
                                              ? order.regular_payment_info
                                                  .slice()
                                                  .sort(
                                                    (a, b) =>
                                                      a.regular_payment_id -
                                                      b.regular_payment_id,
                                                  )
                                                  .pop()
                                              : null,
                                          tax_free: state?.tax_free_amount,
                                        });
                                      }}
                                    >
                                      취소
                                    </span>
                                  ) : onSubmit &&
                                    (order?.delivery_status === 'DELIVERED' ||
                                      order?.delivery_status === 'ON_HOLD') &&
                                    order?.purchase_status === 'PENDING' ? (
                                    <React.Fragment>
                                      {order?.delivery_status ===
                                      'DELIVERED' ? (
                                        <span
                                          style={{
                                            fontSize: 14,
                                            borderRadius: 2,
                                            padding: '2px 4px',
                                            cursor: 'pointer',
                                            color: 'var(--white-color)',
                                            backgroundColor:
                                              'var(--black-color)',
                                            marginTop: 8,
                                          }}
                                          onClick={() =>
                                            onSubmit(
                                              `${order.type}-CONFIRMED`,
                                              {
                                                shop_order_id:
                                                  state.shop_order_id,
                                                parcel_service_id:
                                                  order.parcel_service_id,
                                                purchase_status: 'CONFIRMED',
                                              },
                                            )
                                          }
                                        >
                                          구매확정
                                        </span>
                                      ) : null}

                                      {order?.product?.is_refund === 'Y' ? (
                                        <span
                                          style={{
                                            fontSize: 14,
                                            borderRadius: 2,
                                            padding: '2px 4px',
                                            cursor: 'pointer',
                                            color: 'var(--black-color)',
                                            backgroundColor:
                                              'var(--white-color)',
                                            border:
                                              '1px solid var(--black-color)',
                                            marginTop: 4,
                                          }}
                                          onClick={() => {
                                            setModalType(
                                              `${order.type}-REFUNDED`,
                                            );
                                            setModalData({
                                              shop_order_id:
                                                state.shop_order_id,
                                              type: order.type,

                                              parcel_service_id:
                                                order.parcel_service_id,
                                              refund_amount:
                                                order.product.price *
                                                  order.num +
                                                (order.product.discount_price ??
                                                  0),
                                              refund_num: order.num,
                                              regular_payment_info:
                                                order.regular_payment_info
                                                  ? order.regular_payment_info
                                                      .slice()
                                                      .sort(
                                                        (a, b) =>
                                                          a.regular_payment_id -
                                                          b.regular_payment_id,
                                                      )
                                                      .pop()
                                                  : null,
                                            });
                                          }}
                                        >
                                          환불/반품 요청
                                        </span>
                                      ) : null}

                                      {/* <span
                                        style={{
                                          fontSize: 14,
                                          borderRadius: 2,
                                          padding: '2px 4px',
                                          cursor: 'pointer',
                                          color: 'var(--black-color)',
                                          backgroundColor: 'var(--white-color)',
                                          border:
                                            '1px solid var(--black-color)',
                                          marginTop: 4,
                                        }}
                                        onClick={() => {
                                          setModalType(
                                            `${order.type}-RETURNED`
                                          );
                                          setModalData({
                                            shop_order_id: state.shop_order_id,
                                            type: order.type,

                                            parcel_service_id:
                                              order.parcel_service_id,
                                            refund_amount:
                                              order.product.price * order.num +
                                              (order.product.discount_price ??
                                                0),
                                            refund_num: order.num,
                                            regular_payment_info:
                                              order.regular_payment_info
                                                ? order.regular_payment_info
                                                    .slice()
                                                    .sort(
                                                      (a, b) =>
                                                        a.regular_payment_id -
                                                        b.regular_payment_id
                                                    )
                                                    .pop()
                                                : null,
                                          });
                                        }}
                                      >
                                        교환 요청
                                      </span> */}
                                    </React.Fragment>
                                  ) : null}
                                </div>
                              )
                            ) : null}
                            {/* !SECTION 배송 상태 (일반 배송) */}

                            {/* SECTION 배송 상태 (정기 배송) */}
                            {showExpectedCycle && order.regular_payment_info ? (
                              order.regular_payment_info?.at(-1)
                                ?.delivery_status === 'DELIVERED' &&
                              (order.regular_payment_info?.at(-1)
                                ?.purchase_status === 'CONFIRMED' ||
                                order.regular_payment_info?.at(-1)
                                  ?.purchase_status === 'CALCULATE') ? (
                                <Flex align="center" justify="center">
                                  <Text
                                    style={{
                                      fontSize: 18,
                                      fontWeight: 700,
                                      textAlign: 'center',
                                    }}
                                  >
                                    구매확정
                                  </Text>
                                </Flex>
                              ) : (
                                <Flex
                                  vertical
                                  gap={2}
                                  align="center"
                                  justify="center"
                                >
                                  <Text
                                    style={{
                                      fontSize: 18,
                                      fontWeight: 700,
                                      textAlign: 'center',
                                    }}
                                  >
                                    {
                                      DELIVERY_STATUS[
                                        order.regular_payment_info?.at(-1)
                                          ?.delivery_status
                                      ]?.[order.type]
                                    }
                                  </Text>
                                  {onSubmit &&
                                  order.regular_payment_info?.at(-1)
                                    ?.delivery_status === 'PENDING' &&
                                  order.regular_payment_info?.at(-1)
                                    .purchase_status === 'PENDING' ? (
                                    order.regular_payment_info.length === 1 ||
                                    dayjs
                                      .unix(order.regular_updated_at)
                                      .diff(dayjs.unix(today), 'day') <
                                      (order?.product?.regular_information
                                        ?.cancel_deadline ?? 3) ? (
                                      <span
                                        style={{
                                          fontSize: 14,
                                          borderRadius: 2,
                                          padding: '2px 4px',
                                          cursor: 'pointer',
                                          color: 'var(--white-color)',
                                          backgroundColor: 'var(--black-color)',
                                          marginTop: 8,
                                        }}
                                        onClick={() => {
                                          setModalType(
                                            `${order.type}-CANCELLED`,
                                          );
                                          setModalData({
                                            shop_order_id: state.shop_order_id,
                                            payment_info: state.payment_info,
                                            payment_method:
                                              state.payment_method,

                                            parcel_service_id:
                                              order.parcel_service_id,
                                            refund_amount: order.payment_price,
                                            refund_num: order.num,
                                            tax_rate: order.product.tax_rate,
                                            regular_payment_info:
                                              order.regular_payment_info
                                                ? order.regular_payment_info
                                                    .toSorted(
                                                      (a, b) =>
                                                        a.regular_payment_id -
                                                        b.regular_payment_id,
                                                    )
                                                    .at(-1)
                                                : null,
                                            isFirst:
                                              order.regular_payment_info
                                                .length === 1
                                                ? true
                                                : false,
                                          });
                                        }}
                                      >
                                        취소
                                      </span>
                                    ) : null
                                  ) : onSubmit &&
                                    (order.regular_payment_info?.at(-1)
                                      ?.delivery_status === 'DELIVERED' ||
                                      order.regular_payment_info?.at(-1)
                                        ?.delivery_status === 'ON_HOLD') &&
                                    order.regular_payment_info?.at(-1)
                                      ?.purchase_status === 'PENDING' ? (
                                    <React.Fragment>
                                      {/* 구매확정 */}
                                      {order.regular_payment_info?.at(-1)
                                        ?.delivery_status === 'DELIVERED' ? (
                                        <span
                                          style={{
                                            fontSize: 14,
                                            borderRadius: 2,
                                            padding: '2px 4px',
                                            cursor: 'pointer',
                                            color: 'var(--white-color)',
                                            backgroundColor:
                                              'var(--black-color)',
                                            marginTop: 8,
                                          }}
                                          onClick={() =>
                                            onSubmit(
                                              `${order.type}-CONFIRMED`,
                                              {
                                                shop_order_id:
                                                  state.shop_order_id,
                                                parcel_service_id:
                                                  order.parcel_service_id,
                                                purchase_status: 'CONFIRMED',
                                                regular_payment_info:
                                                  order.regular_payment_info,
                                                regular_payment_id:
                                                  order.regular_payment_info?.at(
                                                    -1,
                                                  )?.regular_payment_id,
                                              },
                                            )
                                          }
                                        >
                                          구매확정
                                        </span>
                                      ) : null}

                                      {order?.product?.is_refund === 'Y' ? (
                                        <span
                                          style={{
                                            fontSize: 14,
                                            borderRadius: 2,
                                            padding: '2px 4px',
                                            cursor: 'pointer',
                                            color: 'var(--black-color)',
                                            backgroundColor:
                                              'var(--white-color)',
                                            border:
                                              '1px solid var(--black-color)',
                                            marginTop: 4,
                                          }}
                                          onClick={() => {
                                            setModalType(
                                              `${order.type}-REFUNDED`,
                                            );
                                            setModalData({
                                              shop_order_id:
                                                state.shop_order_id,

                                              parcel_service_id:
                                                order.parcel_service_id,
                                              refund_amount:
                                                order.product.price *
                                                  order.num +
                                                (order.product.discount_price ??
                                                  0),
                                              refund_num: order.num,
                                              regular_payment_info:
                                                order.regular_payment_info
                                                  ? order.regular_payment_info
                                                      ?.toSorted(
                                                        (a, b) =>
                                                          a.regular_payment_id -
                                                          b.regular_payment_id,
                                                      )
                                                      ?.at(-1)
                                                  : null,
                                            });
                                          }}
                                        >
                                          환불/반품 요청
                                        </span>
                                      ) : null}

                                      {/* <span
                                        style={{
                                          fontSize: 14,
                                          borderRadius: 2,
                                          padding: '2px 4px',
                                          cursor: 'pointer',
                                          color: 'var(--black-color)',
                                          backgroundColor: 'var(--white-color)',
                                          border:
                                            '1px solid var(--black-color)',
                                          marginTop: 4,
                                        }}
                                        onClick={() => {
                                          setModalType(
                                            `${order.type}-RETURNED`
                                          );
                                          setModalData({
                                            shop_order_id: state.shop_order_id,

                                            parcel_service_id:
                                              order.parcel_service_id,
                                            refund_amount:
                                              order.product.price * order.num +
                                              (order.product.discount_price ??
                                                0),
                                            refund_num: order.num,
                                            regular_payment_info:
                                              order.regular_payment_info
                                                ? order.regular_payment_info
                                                    .slice()
                                                    .sort(
                                                      (a, b) =>
                                                        a.regular_payment_id -
                                                        b.regular_payment_id
                                                    )
                                                    .pop()
                                                : null,
                                          });
                                        }}
                                      >
                                        교환요청
                                      </span> */}
                                    </React.Fragment>
                                  ) : null}
                                </Flex>
                              )
                            ) : null}
                            {/* !SECTION 배송 상태 (정기 배송) */}

                            {/* 리뷰 */}
                            {showExpectedCycle && order.regular_payment_info ? (
                              <span
                                onClick={
                                  order.regular_payment_info.some(
                                    (regular) =>
                                      regular?.delivery_status === 'DELIVERED',
                                  )
                                    ? () =>
                                        order.regular_payment_info.some(
                                          (regular) =>
                                            regular?.delivery_status ===
                                            'DELIVERED',
                                        ) && order.review
                                          ? navigate('/mypage/review')
                                          : navigate(
                                              `/mypage/reviewform?orderNum=${encodeURIComponent(
                                                encrypt(
                                                  order.parcel_service_id,
                                                ),
                                              )}&product=${encodeURIComponent(
                                                encrypt(
                                                  order.product.product_id,
                                                ),
                                              )}&type=parcel_service`,
                                            )
                                    : null
                                }
                                style={{
                                  fontSize: 14,
                                  fontWeight: 400,
                                  border: `1px solid ${
                                    order.regular_payment_info.some(
                                      (regular) =>
                                        regular?.delivery_status ===
                                        'DELIVERED',
                                    )
                                      ? 'var(--black-color)'
                                      : '#ddd'
                                  }`,
                                  color: order.regular_payment_info.some(
                                    (regular) =>
                                      regular?.delivery_status === 'DELIVERED',
                                  )
                                    ? 'var(--black-color)'
                                    : '#ddd',
                                  borderRadius: 2,
                                  padding: '10px 16px',
                                  cursor: order.regular_payment_info.some(
                                    (regular) =>
                                      regular?.delivery_status === 'DELIVERED',
                                  )
                                    ? 'pointer'
                                    : 'default',
                                }}
                              >
                                {order.regular_payment_info.some(
                                  (regular) =>
                                    regular?.delivery_status === 'DELIVERED',
                                ) && order.review
                                  ? '리뷰보기'
                                  : '리뷰작성'}
                              </span>
                            ) : (
                              <span
                                onClick={
                                  order?.delivery_status === 'DELIVERED'
                                    ? () =>
                                        order?.delivery_status ===
                                          'DELIVERED' && order.review
                                          ? navigate('/mypage/review')
                                          : navigate(
                                              `/mypage/reviewform?orderNum=${encodeURIComponent(
                                                encrypt(
                                                  order.parcel_service_id,
                                                ),
                                              )}&product=${encodeURIComponent(
                                                encrypt(
                                                  order.product.product_id,
                                                ),
                                              )}&type=parcel_service`,
                                            )
                                    : null
                                }
                                style={{
                                  fontSize: 14,
                                  fontWeight: 400,
                                  border: `1px solid ${
                                    order?.delivery_status === 'DELIVERED'
                                      ? 'var(--black-color)'
                                      : '#ddd'
                                  }`,
                                  color:
                                    order?.delivery_status === 'DELIVERED'
                                      ? 'var(--black-color)'
                                      : '#ddd',
                                  borderRadius: 2,
                                  padding: '10px 16px',
                                  cursor:
                                    order?.delivery_status === 'DELIVERED'
                                      ? 'pointer'
                                      : 'default',
                                }}
                              >
                                {order?.delivery_status === 'DELIVERED' &&
                                order.review
                                  ? '리뷰보기'
                                  : '리뷰작성'}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            },
          },
        ]}
        headerStyle={{
          display: 'none',
        }}
        headRowStyle={{
          border: 'none',
        }}
        bodyRowStyle={{ padding: 0 }}
        bordered={false}
        hovered={false}
        minHeight={orders.length ? 'auto' : 200}
        pagination={false}
        layoutStyle={{ overflow: 'hidden' }}
        minWidth={screenSize > 1550 ? 900 : 0}
      />
      {/* 취소/환불 사유 모달 */}
      <ModalLayout
        open={!!modalType}
        onCancel={() => setModalType(null)}
        width={350}
        centered
        styles={{
          content: {
            borderRadius: 8,
          },
        }}
        title={`주문 ${
          modalType?.includes('CANCELLED')
            ? '취소'
            : modalType?.includes('REFUNDED')
              ? '환불/반품'
              : '교환'
        } 사유`}
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Select
                  size="large"
                  value={selectedValue}
                  placeholder={`${
                    modalType?.includes('CANCELLED')
                      ? '취소'
                      : modalType?.includes('REFUNDED')
                        ? '환불/반품'
                        : '교환'
                  }를 선택해주세요`}
                  style={{ width: '100%' }}
                  options={REFUND_REASON[modalType?.split('-')[1]]?.map(
                    (reason) => ({
                      label: (
                        <div>
                          <Text size={14} weight={600}>
                            {reason.label}
                          </Text>
                          <Text size={12} color={'#BDBDBD'}>
                            {reason.value}
                          </Text>
                        </div>
                      ),
                      value: reason.value,
                    }),
                  )}
                  onChange={(e) => setSelectedValue(e)}
                />
                {selectedValue !== null ? null : (
                  <Input.TextArea
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    style={{ marginTop: 8 }}
                  />
                )}
              </Content>
            </Col>
            <Col x={24}>
              <Text size={12} color={'#D33444'} style={{ marginTop: 5 }}>
                귀책사유에 따라 배송비가 부과될 수 있습니다.
              </Text>
            </Col>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0} style={{ marginTop: 18 }}>
                <Button
                  style={{ width: '100%' }}
                  onClick={async () => {
                    const res = await onSubmit(modalType, {
                      ...modalData,
                      refund_reason: selectedValue ? selectedValue : inputValue,
                    });

                    if (res === 200) {
                      setModalData(null);
                      setInputValue('');
                      setSelectedValue('');
                      setModalType(null);
                    }
                  }}
                >
                  상품{' '}
                  {modalType?.includes('CANCELLED')
                    ? '취소'
                    : modalType?.includes('REFUNDED')
                      ? '환불/반품'
                      : '교환'}
                </Button>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default OrderListTable;
